export const PaidProducts = {
  PRO_MEMBERSHIP: "1",
  EARLY_APPLICANT:"2",
  RESUME_BUILDER: "3",
};

export const PaymentGateway = {
  APPLE: 1,
  PAYU: 2,
};

export const JOB_LOCATIONS = [
  {
    label: 'Metros',
    value: 87,
  },
  {
    label: 'Anywhere in India/Multiple Locations',
    value: 88,
  },
  {
    label: 'Overseas/International',
    value: 89,
  },
  {
    label: 'Ahmedabad',
    value: 53,
  },
  {
    label: 'Amritsar',
    value: 45,
  },
  {
    label: 'Andhra Pradesh',
    value: 34,
  },
  {
    label: 'Aurangabad',
    value: 79,
  },
  {
    label: 'Bangalore',
    value: 3,
  },
  {
    label: 'Bhubaneshwar',
    value: 65,
  },
  {
    label: 'Bihar',
    value: 19,
  },
  {
    label: 'Chandigarh',
    value: 14,
  },
  {
    label: 'Chennai',
    value: 6,
  },
  {
    label: 'Chhattisgarh',
    value: 64,
  },
  {
    label: 'Cochin/Kochi',
    value: 70,
  },
  {
    label: 'Coimbatore',
    value: 84,
  },
  {
    label: 'Cuttack',
    value: 86,
  },
  {
    label: 'Dehradun',
    value: 58,
  },
  {
    label: 'Delhi',
    value: 36,
  },
  {
    label: 'Delhi NCR',
    value: 1,
    selected: [36, 40, 41, 37, 38],
  },
  {
    label: 'Faridabad',
    value: 40,
  },
  {
    label: 'Gandhinagar',
    value: 55,
  },
  {
    label: 'Ghaziabad',
    value: 41,
  },
  {
    label: 'Goa',
    value: 13,
  },
  {
    label: 'Greater Noida',
    value: 39,
  },
  {
    label: 'Gujarat',
    value: 8,
  },
  {
    label: 'Guntur',
    value: 77,
  },
  {
    label: 'Gurgaon/Gurugram',
    value: 37,
  },
  {
    label: 'Guwahati',
    value: 12,
  },
  {
    label: 'Haridwar',
    value: 57,
  },
  {
    label: 'Haryana',
    value: 16,
  },
  {
    label: 'Hosur',
    value: 71,
  },
  {
    label: 'Hubli',
    value: 72,
  },
  {
    label: 'Hyderabad',
    value: 4,
  },
  {
    label: 'Jaipur',
    value: 11,
  },
  {
    label: 'Jalandhar',
    value: 46,
  },
  {
    label: 'Jammu',
    value: 43,
  },
  {
    label: 'Jammu & Kashmir',
    value: 42,
  },
  {
    label: 'Jamshedpur',
    value: 63,
  },
  {
    label: 'Jharkhand',
    value: 20,
  },
  {
    label: 'Jodhpur',
    value: 52,
  },
  {
    label: 'Karnataka',
    value: 31,
  },
  {
    label: 'Kerala',
    value: 17,
  },
  {
    label: 'Kolkata',
    value: 5,
  },
  {
    label: 'Lucknow',
    value: 60,
  },
  {
    label: 'Ludhiana',
    value: 48,
  },
  {
    label: 'Madurai',
    value: 83,
  },
  {
    label: 'Maharashtra',
    value: 9,
  },
  {
    label: 'MP',
    value: 10,
  },
  {
    label: 'Mumbai',
    value: 2,
  },
  {
    label: 'Mysore',
    value: 73,
  },
  {
    label: 'Nagpur',
    value: 66,
  },
  {
    label: 'Nasik',
    value: 67,
  },
  {
    label: 'Navi Mumbai',
    value: 68,
  },
  {
    label: 'Noida',
    value: 38,
  },
  {
    label: 'Odisha',
    value: 18,
  },
  {
    label: 'Panipat',
    value: 50,
  },
  {
    label: 'Patiala',
    value: 47,
  },
  {
    label: 'Patna',
    value: 61,
  },
  {
    label: 'Pondicherry',
    value: 85,
  },
  {
    label: 'Pune',
    value: 7,
  },
  {
    label: 'Punjab',
    value: 15,
  },
  {
    label: 'Raipur',
    value: 74,
  },
  {
    label: 'Rajasthan',
    value: 33,
  },
  {
    label: 'Rajkot',
    value: 80,
  },
  {
    label: 'Ranchi',
    value: 62,
  },
  {
    label: 'Sonipat',
    value: 49,
  },
  {
    label: 'Srinagar',
    value: 44,
  },
  {
    label: 'Surat',
    value: 54,
  },
  {
    label: 'Tamil Nadu',
    value: 32,
  },
  {
    label: 'Telangana',
    value: 35,
  },
  {
    label: 'Thane',
    value: 69,
  },
  {
    label: 'Trivandrum/Thiruvananthapuram',
    value: 75,
  },
  {
    label: 'Udaipur',
    value: 51,
  },
  {
    label: 'UP',
    value: 21,
  },
  {
    label: 'Uttarakhand',
    value: 59,
  },
  {
    label: 'Vadodara/Baroda',
    value: 56,
  },
  {
    label: 'Varanasi/Banaras',
    value: 81,
  },
  {
    label: 'Vijayawada',
    value: 76,
  },
  {
    label: 'Vishakhapatnam/Vizag',
    value: 78,
  },
  {
    label: 'Warangal',
    value: 82,
  },
  {
    label: 'Abu Dhabi',
    value: 100,
  },
  {
    label: 'Afghanistan',
    value: 109,
  },
  {
    label: 'Africa',
    value: 26,
  },
  {
    label: 'Bahrain',
    value: 90,
  },
  {
    label: 'Bangladesh',
    value: 107,
  },
  {
    label: 'Bhutan',
    value: 105,
  },
  {
    label: 'China',
    value: 108,
  },
  {
    label: 'Dhaka',
    value: 106,
  },
  {
    label: 'Doha',
    value: 98,
  },
  {
    label: 'Dubai',
    value: 91,
  },
  {
    label: 'Egypt',
    value: 113,
  },
  {
    label: 'Ethiopia',
    value: 112,
  },
  {
    label: 'EU',
    value: 28,
  },
  {
    label: 'Hong Kong',
    value: 30,
  },
  {
    label: 'Indonesia',
    value: 103,
  },
  {
    label: 'Kabul',
    value: 92,
  },
  {
    label: 'Kenya',
    value: 114,
  },
  {
    label: 'Kuwait',
    value: 93,
  },
  {
    label: 'London',
    value: 95,
  },
  {
    label: 'Malaysia',
    value: 27,
  },
  {
    label: 'Middle East',
    value: 25,
  },
  {
    label: 'Muscat',
    value: 97,
  },
  {
    label: 'Nairobi',
    value: 115,
  },
  {
    label: 'Nepal',
    value: 104,
  },
  {
    label: 'Nigeria',
    value: 94,
  },
  {
    label: 'Oman',
    value: 96,
  },
  {
    label: 'Pakistan',
    value: 110,
  },
  {
    label: 'Philippines',
    value: 120,
  },
  {
    label: 'Qatar',
    value: 99,
  },
  {
    label: 'Riyadh',
    value: 102,
  },
  {
    label: 'Saudi Arabia',
    value: 101,
  },
  {
    label: 'Singapore',
    value: 24,
  },
  {
    label: 'South Africa',
    value: 117,
  },
  {
    label: 'Sri Lanka',
    value: 111,
  },
  {
    label: 'Tanzania',
    value: 116,
  },
  {
    label: 'UK',
    value: 23,
  },
  {
    label: 'US',
    value: 22,
  },
  {
    label: 'Zambia',
    value: 119,
  },
  {
    label: 'Zimbabwe',
    value: 118,
  },
  {
    label: 'Others',
    value: 100000,
  },
  {
    label: 'Mizoram',
    value: 122,
  },
  {
    label: 'Assam',
    value: 123,
  },
  {
    label: 'Manipur',
    value: 124,
  },
  {
    label: 'Meghalaya',
    value: 125,
  },
  {
    label: 'Tripura',
    value: 126,
  },
  {
    label: 'Arunachal Pradesh',
    value: 127,
  },
  {
    label: 'Nagaland',
    value: 128,
  },
  {
    label: 'West Bengal',
    value: 129,
  },
  {
    label: 'Indore',
    value: 130,
  },
];
